import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormFieldConfig } from '../model/form.model';

@Injectable({ providedIn: 'root' })
export class FormService {
  private readonly formSubject = new Subject<FormGroup>();
  form$ = this.formSubject.asObservable();

  sendForm(form: any, fieldArray?: FormFieldConfig[], formName?:string) {
    if(fieldArray){
      form['fieldArray'] = fieldArray
    }
    if(formName){
      form['formName'] = formName
    }
    this.formSubject.next(form);
  }
}